module.exports = __webpack_public_path__ + "assets/img/W2-4-F.f1e07c2b.png";